import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface FixedUserBadgeProps {
  profile: any;
  user: any;
}

export function FixedUserBadge({ profile, user }: FixedUserBadgeProps) {
  // Componente desativado - removido da interface
  return null;
}